export default __webpack_public_path__ + "static/media/rocket.9dd581ae.gif";